import React, { forwardRef } from "react";
import { Box, styled } from "@mui/material";

const FormCard = forwardRef((props, ref) => {
  return <CustomBox ref={ref} {...props} />;
});

FormCard.displayName = "FormCard";

const CustomBox = styled(Box)({
  border: "1px solid #ebebeb",
  borderRadius: "5px",
  padding: "24px",
  margin: "16px 0",
});
export default FormCard;
